import { Actions as FetchReleasedClientsWithDashboardActions } from 'actions/releasedClientsWithDashboard';
import { AxiosError } from 'axios';
import { IClientWithRanking } from 'interfaces/clientWithRanking';

export type State = {
  isFetching: boolean;
  releasedClientsWithDashboard?: IClientWithRanking[];
  error: AxiosError | null;
};

type Actions = FetchReleasedClientsWithDashboardActions;

const initialState: State = {
  isFetching: false,
  releasedClientsWithDashboard: [],
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_RELEASED_CLIENTS_WITH_DASHBOARD_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_RELEASED_CLIENTS_WITH_DASHBOARD_SUCCESS':
      return {
        isFetching: false,
        releasedClientsWithDashboard: action.payload.sort((a, b) => a.name.localeCompare(b.name)),
        error: null
      };
    case 'FETCH_RELEASED_CLIENTS_WITH_DASHBOARD_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
